import useGrowthBookFeatureValue from 'components/GrowthBookProvider/useGrowthBookFeatureValue';
import { useSelector } from 'react-redux';

/**
 * Feature flag name for the personalization A/B test
 */
export const PERSONALIZATION_FEATURE_FLAG = 'disable_personalization';

/**
 * Custom hook to check if personalization features should be enabled
 * @returns {boolean} True if personalization features should be enabled, false otherwise
 */
export const usePersonalizationFeatures = () => {
  // Get the flag value from GrowthBook - if it's true, personalization is disabled
  const disablePersonalization = useGrowthBookFeatureValue(PERSONALIZATION_FEATURE_FLAG);
  // Return the opposite of disablePersonalization (if true, features are disabled, so we return false)
  return disablePersonalization !== true;
};

/**
 * Custom hook to check if bus diagram in results should be enabled
 * @returns {boolean} True if bus diagram should be enabled, false otherwise
 */
export const useBusDiagramEnabled = () => {
  const { features } = useSelector((state) => state.whitelabelConfig);
  const personalizedFeaturesEnabled = usePersonalizationFeatures();

  // Respects both the base SEATS_ON_RESULTS feature and the personalization feature flag
  return features.SEATS_ON_RESULTS && personalizedFeaturesEnabled;
};
